import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { api } from '../api-client.config';

const updateUserStatus = ({
  contestId,
  userId,
  isAlive,
}: {
  contestId: number;
  userId: number;
  isAlive: boolean;
}) =>
  api.put(`/contests/${contestId}/users/${userId}`, {
    is_alive: isAlive,
  });

export const useUpdateUserStatusMutation = ({
  isAlive,
  userId,
  contestId,
}: {
  isAlive: boolean;
  userId: number;
  contestId: number;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['contests', contestId, 'users', userId],
    mutationFn: () => updateUserStatus({ contestId, userId, isAlive }),
    onSuccess: () => {
      toast.success('User status updated successfully');

      queryClient.invalidateQueries({
        queryKey: ['contests', contestId, 'users'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
